import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import XeroInputDataForm from './XeroInputDataForm';
import RemoteSubmitButton from '../../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class XeroInputDataDialog extends Component {
	dialogConfig() {
		const { t, onCancel } = this.props;

		return {
			header: t('Xero_InputData'),
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};
	}

	renderBody() {
		const { onConfirm } = this.props;
		return <XeroInputDataForm onSubmit={onConfirm} />;
	}

	renderFooter() {
		const { onCancel, t } = this.props;

		const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
		const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='xeroInputData' label={t('Xero_InputDataContinue')} />;
		return [closeBtn, confirmBtn];
	}

	render() {
		const { show, block, unblock } = this.props;
		const dialogConfig = this.dialogConfig();
		return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
	}
}

XeroInputDataDialog.propTypes = {
	show: PropTypes.bool,
	block: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	unblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(XeroInputDataDialog);